import WithRoleAuthorization, { Role, listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'
import { notificationStatus } from 'constants/notificationStatus'
import { ButtonAction } from 'pages/NotifyEvent/styles'
import { useMemo } from 'react'
import { UserDataType } from 'types/autentication'
import { getDamage } from 'utils/damage'


export interface IForwardToFinish {
  currentUser: UserDataType
  forwardToFinish({ type }: {
    type: 'forward' | 'finish';
  }): void
  notificationStatusState: string
  actionsBack: string
  loggedInUserIsResponsible: boolean
  currentStepSelected: number
  damageLevel: { display_value: string, value: string }
  imageRisk: {
    display_value: string;
    value: string;
  }

}
const canForwardToFinishRoles = ({loggedInUserIsResponsible}:{loggedInUserIsResponsible:boolean}) => {
  return [
    ...(loggedInUserIsResponsible ? [listOfRoles.location_manager]:[]),
  ]
}
export const canKindOfDamages = ['grave', 'obito']
export const cantForwardToFinishStep = [6]
export default function ForwardToFinish({ damageLevel, imageRisk, currentStepSelected, currentUser, forwardToFinish, actionsBack,
  notificationStatusState, loggedInUserIsResponsible }: IForwardToFinish) {
  const damage = useMemo(() => {
    return getDamage(damageLevel?.value)
  }, [damageLevel])
  const isKindOfDamage = canKindOfDamages.includes(damage?.value)
  const isImageRisk = imageRisk?.value == 'true' || imageRisk?.value == 'u_image_risk_yes'
  const shouldRenderButton = isKindOfDamage || isImageRisk
  const isaForwardToFinishStep = cantForwardToFinishStep.includes(currentStepSelected);
  const isAlreadyPending = notificationStatusState === notificationStatus[3].label

  if (!shouldRenderButton || !isaForwardToFinishStep || isAlreadyPending) {
    return null
  }


  return (
    <>
      <WithRoleAuthorization allowedRoles={canForwardToFinishRoles({loggedInUserIsResponsible})}
        userRole={currentUser?.profile}
        children={
          <ButtonAction
            data-testid="test-forward-to-finish-button"
            type="button"
            onClick={() => forwardToFinish({ type: 'forward' })}
            className={actionsBack}
          >
            Encaminhar para finalização
          </ButtonAction>
        }
      />
    </>
  )
}
